/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleChevronDown = createReactComponent(
  "circle-chevron-down",
  "IconCircleChevronDown",
  [
    ["path", { d: "M15 11l-3 3l-3 -3", key: "svg-0" }],
    ["path", { d: "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z", key: "svg-1" }]
  ]
);

export { IconCircleChevronDown as default };
//# sourceMappingURL=IconCircleChevronDown.js.map
